import React from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

function DeleteModal({ modalDelete, setModalDelete, deleteItem, showNote, setNote }) {
	const { t } = useTranslation()

	return (
		<>
			<Modal show={modalDelete?.show ?? modalDelete} animation={false}
				centered dialogClassName="update-modal-width"
				onHide={() => setModalDelete(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{showNote ?
							t('are_you_sure_you_want_delete')
							:
							t('delete')
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{showNote ?
						<div className="form-group">
							<label>{t('note')}</label>
							<textarea type="text" className="form-control" name="note" value={modalDelete?.note}
								onChange={(e) => setNote({ ...modalDelete, 'note': e.target.value })} />
						</div>
						:
						t('are_you_sure_you_want_delete')
					}
				</Modal.Body>
				<Modal.Footer >
					<div className="d-flex gap-2 w-100">
						<button className="btn btn-warning w-100" onClick={() => setModalDelete(false)}>
							{t('cancel')}
						</button>
						{showNote ?
							<button className="btn btn-danger w-100" disabled={!modalDelete?.note} onClick={() => deleteItem()}>{t('delete')}</button>
							:
							<button className="btn btn-danger w-100" onClick={() => deleteItem()}>{t('delete')}</button>
						}
					</div>
				</Modal.Footer>
			</Modal>
		</>
	)
}

export default DeleteModal
